<template>
  <b-form @submit.prevent>
    <b-row>
      <b-col>
        <b-form-input
          v-if="!isRecording"
          name="type"
          v-model="text"
          placeholder="Entrez votre message..."
          class="form-control"
          @keyup.enter="triggerText"
          :disabled="isSending || isDisabled"
          style="border-radius: 25px; border: 0px"
        />
      </b-col>

      <b-col cols="3" md="2" lg="2" xl="2" class="d-flex align-items-center">
        <reply-image v-if="!isSending && !isDisabled && !isRecording" @image="triggerImage" class="mr-4" />

        <reply-audio v-if="!isSending && !isDisabled" @audio="triggerVocal" :is-recording.sync="isRecording" class="mr-4" />

        <img
          v-if="!isSending && !isDisabled && !isRecording"
          @click="triggerText"
          src="@/assets/icons/send.svg"
          width="25"
          height="25"
          class="mx-auto cursor-pointer"
        />

        <div v-else-if="isRecording" />

        <img v-else src="@/assets/animations/loader-dots.svg" width="25" height="25" class="mx-auto" />
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { BRow, BCol, BForm, BFormInput } from "bootstrap-vue";

import ReplyImage from "./ReplyImage";
import ReplyAudio from "./ReplyAudio";

export default {
  name: "Write",
  components: { BRow, BCol, BForm, BFormInput, ReplyImage, ReplyAudio },
  props: {
    isSending: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    text: null,

    isRecording: false,
  }),
  watch: {
    isSending() {
      const { isSending } = this;
      if (!isSending) this.text = null;
    },
  },
  methods: {
    async triggerText(e) {
      if (e) e.preventDefault();

      const { text, isSending } = this;
      if (!text || isSending) return;

      this.$emit("success", { content: text, type: "text" });
    },

    async triggerVocal({ audioId, ...others }) {
      const { isSending } = this;
      if (!audioId || isSending) return;

      this.$emit("success", { content: { audioId, ...others }, type: "audio" });
    },
    async triggerImage({ imageId, ...others }) {
      const { isSending } = this;
      if (!imageId || isSending) return;

      this.$emit("success", { content: { imageId, ...others }, type: "image" });
    },
  },
};
</script>
